import app from 'flarum/forum/app';

import addUnreadToolbarToggle from './addUnreadToolbarToggle';

export { default as extend } from './extend';

app.initializers.add('erp-russia-unread-feed', () => {
  addUnreadToolbarToggle();
});
